// Auto-split from i18n.js — language: de
export default {
    translation: {
        // routes & menus
        Dashboard: 'Instrumententafel',
        'Space Data': 'Platz',
        'Equipment Data': 'Ausrüstung',
        'Meter Data': 'Meter',
        'Tenant Data': 'Mieter',
        'Store Data': 'Geschäft',
        'Shopfloor Data': 'Werkstatt',
        'Combined Equipment Data': 'Kombinierte Ausrüstung',
        'Auxiliary System': 'Hilfssystem',
        Microgrid: 'Mikronetz',
        'Energy Storage Power Station': 'Kraftwerk',
        'Photovoltaic Power Station': 'Kraftwerk',
        'Fault Alarm': 'Fehleralarm',
        Monitoring: 'Überwachung',
        'Advanced Reporting': 'Erweiterte Berichterstellung',
        'Knowledge Base': 'Wissensbasis',
        'Energy Category Data': 'Energiekategorie',
        'Energy Item Data': 'Unterpunkt Energieverbrauch',
        Carbon: 'CO2 Emissionen',
        Cost: 'Kosten',
        Output: 'Ausgang',
        Income: 'Einkommen',
        Efficiency: 'Effizienz',
        Load: 'Stromlast',
        Statistics: 'Statistiken',
        'Batch Analysis': 'Charge Analyse',
        Saving: 'SparenⒺ',
        Plan: 'PlanenⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Ausrüstung Datei',
        'Equipment Comparison': 'Ausrüstung Vergleich',
        'Shopfloor Comparison': 'Ausrüstung Vergleich',
        'Store Comparison': 'Geschäfte  Vergleich',
        'Space Comparison': 'Raumvergleich',
        'Combined Equipment Comparison': 'Ausrüstung Vergleich',
        'Tenant Comparison': 'Vergleich der Mieter',
        'Environment Monitor': 'Umgebungsmonitor',
        'Meter Energy': 'Meter Energie ',
        'Meter Prediction': 'ZählerprognoseⒺ',
        'Virtual Meter Prediction': 'Virtuelle ZählerprognoseⒺ',
        'Offline Meter Prediction': 'Offline-ZählerprognoseⒺ',
        'Meter Carbon': 'Meter CO2 Emissionen',
        'Meter Cost': 'Meter Kosten',
        'Meter Trend': 'Meter Trend',
        'Meter Realtime': 'Meter Echtzeit',
        'Meter Saving': 'Meter SparenⒺ',
        'Meter Plan': 'MeterplanⒺ',
        'Master Meter Submeters Balance': 'Master Meter Submeters Balance',
        'Meter Batch Analysis': 'Meter Charge Analyse',
        'Meter Comparison': 'Meter Vergleich',
        'Meter Tracking': 'Meterverfolgung',
        'Virtual Meter Saving': 'Virtual Meter SparenⒺ',
        'Virtual Meter Plan': 'Virtueller ZählerplanⒺ',
        'Virtual Meter Energy': 'Virtuelles Meter Energie',
        'Virtual Meter Carbon': 'Virtuelles Meter CO2 Emissionen',
        'Virtual Meter Cost': 'Virtuelles Meter Kosten',
        'Virtual Meter Batch Analysis': 'Virtuelles Meter Charge Analyse',
        'Virtual Meter Comparison': 'Vergleich virtueller Zähler',
        'Offline Meter Energy': 'Offline Meter Energie',
        'Offline Meter Carbon': 'Offline Meter CO2 Emissionen',
        'Offline Meter Cost': 'Offline Meter Kosten',
        'Offline Meter Batch Analysis': 'Offline Meter Charge Analyse',
        'Offline Meter Saving': 'Offline Meter SparenⒺ',
        'Offline Meter Plan': 'Offline-ZählerplanⒺ',
        'Offline Meter Input': 'Offline-Zählereinstellung',
        'Tenant Bill': 'Mieter Rechnung',
        'Energy Flow Diagram': 'Energieflussdiagramm',
        'Distribution System': 'Vertriebssystem',
        'SVG System': 'SCADA-Visualisierungssystem',
        'Faults Data': 'Fehler',
        'Space Equipments': 'Platz Ausrüstung',
        'Combined Equipments': 'Kombinierte Ausrüstung',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Gesamtzahl der Arbeitsaufträge',
        'Number of New Work Orders': 'Anzahl der neuen Arbeitsaufträge',
        'Number of Inprogress Work Orders': 'Anzahl der laufenden Arbeitsaufträge',
        'Number of Done Work Orders': 'Anzahl der erledigten Arbeitsaufträge',
        'Fuel Indicator': 'Kraftstoffverbrauch',
        'Charge Energy Indicator': 'Ladeenergie',
        'Discharge Energy Indicator': 'Entladeenergie',
        'Charge Cost Indicator': 'Ladekosten',
        'Discharge Revenue Indicator': 'Entladeeinnahmen',
        'HVAC': 'HVAC',
        'Fire Control': 'Brandschutz',
        'Store Dashboard': 'Store Dashboard',
        'Comprehensive overview of store energy performance': 'Umfassende Übersicht der Store-Energieleistung',
        'Total Stores': 'Gesamtzahl der Stores',
        'Total Area': 'Gesamtfläche',
        'Active Meters': 'Aktive Zähler',
        'Active Alerts': 'Aktive Warnungen',
        'Total Energy Consumption': 'Gesamtenergieverbrauch',
        'Carbon Emissions': 'Kohlenstoffemissionen',
        'Current Period': 'Aktueller Zeitraum',
        'Energy Consumption by Category': 'Energieverbrauch nach Kategorie',
        'Cost Distribution by Category': 'Kostenverteilung nach Kategorie',
        'Monthly Energy & Cost Trends': 'Monatliche Energie- und Kostentrends',
        'Top 5 Energy Consuming Stores': 'Top 5 energieintensivste Stores',
        'Energy Category Details': 'Energiekategorie-Details',
        'Store Performance Overview': 'Store-Leistungsübersicht',
        'YoY Change': 'Jährliche Veränderung',
        'Per m²': 'Pro m²',
        'Usage Intensity': 'Nutzungsintensität',
        'Dashboard data loaded successfully': 'Dashboard-Daten erfolgreich geladen',
        'Failed to load dashboard data': 'Dashboard-Daten konnten nicht geladen werden',
        'Store Name': 'Filialname',
        'Store Area': 'Filialfläche',
        'Energy Consumption': 'Energieverbrauch',
        'Consumption': 'Verbrauch',
        'last period': 'letzte Periode',
        // Tenant Dashboard
        'Tenant Dashboard': 'Mieter-Dashboard',
        'Comprehensive overview of tenant energy performance': 'Umfassende Übersicht über die Energieleistung der Mieter',
        'Total Tenants': 'Gesamtzahl der Mieter',
        'Tenant Performance Overview': 'Übersicht der Mieterleistung',
        'Tenant Name': 'Mietername',
        'Tenant Area': 'Mieterfläche',
        'Tenant Type': 'Mietertyp',
        // Equipment Dashboard
        'Equipment Dashboard': 'Geräte-Dashboard',
        'Total Equipments': 'Geräte gesamt',
        'Equipment Performance Overview': 'Geräte-Leistungsübersicht',
        'Equipment Name': 'Gerätename',
        'Equipment Type': 'Gerätetyp',
        'Total Energy': 'Gesamtenergie',
        'Total Sensors': 'Sensoren gesamt',
        'Increment Rate': 'Zuwachsrate',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Gesamtzahl Werkstätten',
        'Shopfloor Performance Overview': 'Werkstättenleistungsübersicht',
        'Shopfloor Name': 'Werkstattname',
        'Shopfloor Area': 'Werkstattfläche',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Gesamtzahl kombinierter Geräte',
        'Combined Equipment Performance Overview': 'Übersicht der Leistung kombinierter Geräte',
        'Combined Equipment Name': 'Name des kombinierten Geräts',
        'Associated Equipments': 'Zugehörige Geräte',

        // Dashboard
        'Welcome to QiXuan': 'Willkommen bei QiXuan',
        'An Industry Leading Energy Management System': 'Ein branchenführendes Energie Management System',
        "This Year's Consumption CATEGORY VALUE UNIT": 'Der Verbrauch Dieses Jahr {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Der Kosten Dieses Jahr {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Der Verbrauch Dieses Monat {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": 'Der Kosten Dieses Monat {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'Der Verbrauch {{CATEGORY}} {{VALUE}} {{UNIT}} im gleichen Zeitraum im vergangenen Jahr',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'Der Kosten {{CATEGORY}} {{VALUE}} {{UNIT}} im gleichen Zeitraum im vergangenen Jahr',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} Verbrauch {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} Kosten {{UNIT}}',
        // Entities
        Space: 'Platz',
        Equipment: 'Ausrüstung',
        Meter: 'Meter',
        'Offline Meter': 'Offline Meter',
        'Virtual Meter': 'Virtuelles Meter',
        Tenant: 'Mieter',
        Store: 'Geschäft',
        Shopfloor: 'Werkstatt',
        'Combined Equipment': 'Kombinierte Ausrüstung',
        'Cost Center': 'Kostenstelle',
        Name: 'Name',
        DisplayName: 'Anzeigename',
        UserName: 'Nutzername',
        Description: 'Beschreibung',
        'Energy Category': 'Energiekategorie',
        'Child Spaces': 'Teil Platz',
        'Associated Equipment': 'Dazugehörige Geräte',
        //Energy Categories
        Electricity: 'Elektrizität',
        Water: 'Wasser',
        'Natural Gas': 'Erdgas',
        // SidePanelModal
        Settings: 'Einstellungen',
        'Set your own customized style': 'Stellen Sie Ihren eigenen Stil ein',
        'Color Scheme': 'Farbschema',
        'Choose the perfect color mode for your app': 'Wählen Sie den perfekten Farbmodus für Ihre App',
        Light: 'Helle',
        Dark: 'Dunkle',
        'RTL Mode': 'RTL-Modus',
        'Switch your language direction': 'Wechseln Sie Ihre Sprachrichtung',
        'Fluid Layout': 'Flüssigkeitsanordnung',
        'Toggle container layout system': 'Container-Layout-System umschalten',
        'Navigation Position': 'Navigationsposition',
        'Vertical': 'Vertikal',
        'Top': 'oben',
        'Combo': 'Kombination',
        'Transparent': 'Transparent',
        'Inverted': 'Umgekehrt',
        'Card': 'Kartenansicht',
        'Vibrant': 'Lebendig',
        'Select a suitable navigation system for your web application':
            'Wählen Sie ein geeignetes Navigationssystem für Ihre Webanwendung',
        'Vertical Nav': 'Vertikale Navigation',
        'Top Nav': 'Top Nav',
        'Vertical Navbar Style': 'Vertikaler Navbar-Stil',
        'Switch between styles for your vertical navbar':
            'Wechseln Sie zwischen den Stilen für Ihre vertikale Navigationsleiste',
        Language: 'Sprache',
        'Switch between languages': 'Zwischen den Sprachen wechseln',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Wie was du siehst?',
        'Get QiXuan now': 'Holen Sie sich jetzt QiXuan',
        Purchase: 'Enterprise Edition',
        ContactInfo: 'Kontaktinformationen',
        ProductWebsite: 'Produktwebsite',
        CompanyWebsite: 'Firmenwebsite',
        SalesPhone: 'Verkaufstelefon',
        // Query Panels
        'Base Period Begins': 'Basisperiode beginnt',
        'Base Period Ends': 'Basisperiode endet',
        'Comparison Types': 'Vergleichstypen',
        'Year-Over-Year': 'Jahr für Jahr',
        'Month-On-Month': 'Monat für Monat',
        'Free Comparison': 'Freier Vergleich',
        'None Comparison': 'Kein Vergleich',
        'Reporting Period Begins': 'Berichtszeitraum beginnt',
        'Reporting Period Ends': 'Berichtszeitraum endet',
        '(Optional)': '(Optional)',
        'Period Types': 'Periodentypen',
        Yearly: 'Jährlich',
        Monthly: 'Monatlich',
        Weekly: 'Wöchentlich',
        Daily: 'Täglich',
        Hourly: 'Stündlich',
        Submit: 'einreichen',
        'Input Energy Category': 'Eingangsenergiekategorie',
        'Output Energy Category': 'Ausgangsenergiekategorie',
        'Fraction Parameter': 'Fraktion Parameter',
        Search: 'Suche',
        //DateRangePicker
        sunday: 'So',
        monday: 'Mo',
        tuesday: 'Di',
        wednesday: 'Mi',
        thursday: 'Do',
        friday: 'Fr',
        saturday: 'Sa',
        ok: 'OKAY',
        today: 'Heute',
        yesterday: 'Gestern',
        hours: 'Stunden',
        minutes: 'Protokoll',
        seconds: 'Nachschlag',
        last7Days: 'Letzte 7 Tage',
        tomorrow: 'Morgen',
        dayAfterTomorrow: 'Übermorgen',
        next7Days: 'Nächste 7 Tage',
        'Select Date Range': 'Datumsbereich auswählen',
        //Card Summaries and Line Charts
        'Base Period': 'Basiszeitraum',
        'Reporting Period': 'Berichtszeitraum',
        'Per Unit Area': 'Pro Flächeneinheit',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'Produktion pro Einheit',
        Baseline: 'Basiswert',
        Actual: 'Istwert',
        'Baseline Value - Actual Value': 'Basiswert - Istwert',
        'Average Load': 'Durchschnittliche Belastung',
        'Maximum Load': 'Maximale Last',
        'Load Factor': 'Ladefaktor',
        'Ratio of Average Load to Maximum Load': 'Verhältnis von durchschnittlicher Last zu maximaler Last',
        'Carbon Dioxide Emissions by Energy Category': 'Kohlendioxidemissionen nach Energiekategorien',
        'Costs by Energy Category': 'Kosten nach Energiekategorie',
        'Incomes by Energy Category': 'Einkommen nach Energiekategorie',
        'Electricity Consumption by Time-Of-Use': 'Stromverbrauch nach Nutzungsdauer',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': 'Emission von Kohlendioxid bei Zeitaufteilung',
        'Electricity Cost by Time-Of-Use': 'Kosten des Stromverbrauchs nach Zeiteinteilung',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} nach Unterpunkt Energieverbrauch',
        'Ton of Standard Coal by Energy Category': 'Tonne Standardkohle(TCE) nach Energiekategorie',
        'Ton of Carbon Dioxide Emissions by Energy Category': 'Tonne Kohlendioxidemissionen(TCO2E) nach Energiekategorie',
        'Reporting Period Consumption CATEGORY UNIT': 'Verbrauch des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} Verbrauch des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Verbrauch des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Verbrauch des Berichtszeitraums {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Verbrauch des Basiszeitraums {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT':
            'Verbrauch des Berichtszeitraums {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'Verbrauch des Berichtszeitraums {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT':
            'Verbrauch des Basiszeitraums {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Anteil des Teil Platz nach Energiekategorie {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Anteil des Teil Platz Gesamtanteil',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'Berichtszeitraum Kohlendioxidemissionen {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Berichtszeitraum Kohlendioxidemissionen {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Basiszeitraum Kohlendioxidemissionen {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Berichtszeitraumkosten {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Berichtszeitraumkosten {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Kosten des Basiszeitraums {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Ausgabe des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{EQUIPMENT}} Ausgabe des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Ausgabe des Berichtszeitraums {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Ausgabe des Berichtszeitraums {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Basisperiodenausgabe {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Berichtsperiodeneinkommen {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Berichtsperiodeneinkommen {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Basisperiodeneinkommen {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Berichtszeitraum Gesamteinkommen {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Berichtszeitraum Kumulative Effizienz {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} Berichtszeitraum Kumulative Effizienz {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Berichtszeitraum Kumulative Gesamteffizienz {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Berichtszeitraum Kumulative Gesamteffizienz {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Basisperiode Kumulative Gesamteffizienz {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Sofortige Effizienz {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Sofortige Effizienz {{UNIT}}',
        'Equipment Efficiency Indicator': 'Geräteenergieeffizienzindikator',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Sofortige umfassende Effizienz {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Berichtszeitraum Kumulative Effizienz {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'Berichtszeitraum Kumulative Effizienz {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Kumulative Effizienz der Basisperiode {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT':
            'Kumulative Effizienz der Basisperiode {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Basiszeitraum {{CATEGORY}} Maximale Last {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Berichtszeitraum {{CATEGORY}} Maximale Last {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT':
            'Berichtszeitraum {{CATEGORY}} Durchschnittliche Belastung {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Berichtszeitraum {{CATEGORY}} Ladefaktor',
        'Base Period CATEGORY Average Load VALUE UNIT':
            'Basiszeitraum {{CATEGORY}} Durchschnittliche Belastung {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Berichtszeitraum {{CATEGORY}} Durchschnittswert {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Berichtszeitraum {{CATEGORY}} Höchster Wert {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Berichtszeitraum {{CATEGORY}} Mindestwert {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Berichtszeitraum {{CATEGORY}} Arithmetisches Mittel {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Berichtszeitraum {{CATEGORY}} Median (Mittlerer Wert) {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Berichtszeitraum {{CATEGORY}} Standardabweichung der Probe {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Berichtszeitraum {{CATEGORY}} Stichprobenvarianz {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'Einsparungen im Berichtszeitraum {{CATEGORY}} (Grundlinie - Ist) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'Berichtszeitraum verkürzt {{CATEGORY}} (Grundlinie - Ist) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Einsparungen im Berichtszeitraum {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Einsparungen in der Basisperiode {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'Berichtszeitraum Master Meter Verbrauch {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'Berichtszeitraum Master Meter Verbrauch {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT':
            'Berichtszeitraum Submeters Verbrauch {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'Berichtszeitraum Submeters Verbrauch {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Unterschied im Berichtszeitraum {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Unterschied im Prozentsatz Berichtszeitraum',
        'Reporting Period Difference CATEGORY VALUE UNIT':
            'Unterschied im Berichtszeitraum {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Fehlerliste',
        'Reporting Period Number of Fault VALUE': 'Berichtszeitraum Anzahl der Fehler: {{VALUE}}',
        'All Faults': 'Alle Fehler',
        'Space Faults': 'Platz Fehler',
        'Number of All Faults': 'Anzahl aller Fehler',
        'Number of Space Faults': 'Anzahl der Platz Fehler',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'Tonne Standardkohle',
        'Ton of Carbon Dioxide Emissions': 'Tonne Kohlendioxidemissionen',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Kohlenstoffemissionen pro Einheit Energieverbrauch',
        'Operating Characteristic Curve': 'Betriebscharakteristikkurve',
        Tariff: 'Tarif',
        'Detailed Data': 'Detaillierte Daten',
        'Child Spaces Data': 'Teil Platz Daten',
        'Associated Equipment Data': 'Dazugehörige Geräte Daten',
        'This Year': 'Dieses Jahr',
        'The Same Period Last Year': 'gleichen Zeitraum im vergangenen Jahr',
        'This Month': 'Diesen Monat',
        'This Day': 'Dieser Tag',
        Total: 'Gesamt',
        'No data found': 'Keine Daten gefunden',
        Export: 'Export',
        'AI Analysis': 'KI-Analyse',
        Datetime: 'Terminzeit',
        'Time-Of-Use Type': 'Art der Zeitteilung',
        'Top-Peak': 'Top-Peak',
        'On-Peak': 'On-Peak',
        'Mid-Peak': 'Mid-Peak',
        'Off-Peak': 'Off-Peak',
        'Deep': 'Deep-Valley',
        Percentage: 'Prozentsatz',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Trend in der letzten Stunde des Energiewertpunkts',
        Circuit: 'Schaltkreis',
        Point: 'Punkt',
        'Realtime Value': 'Echtzeitwert',
        //Meter Tracking
        'Meter List': 'Zählerliste',
        'Edit Meter': 'bearbeiten',
        'Start Value': 'Wert des Starts',
        'End Value': 'Wert des Ends',
        'Difference Value': 'Differenzwert',
        'Start Integrity Rate': 'Start Integritätsrate(%)',
        'End Integrity Rate': 'End Integritätsrate(%)',
        'Full Integrity Rate': 'Vollständige Integritätsrate(%)',
        'Start Integrity Rate Description': 'Anfangsdaten-Integritätsrate: Anteil der Geräte, bei denen während des statistischen Zeitraums erfolgreich Energieverbrauchswerte zum Startzeitpunkt abgerufen wurden, an allen Geräten',
        'End Integrity Rate Description': 'Enddaten-Integritätsrate: Anteil der Geräte, bei denen während des statistischen Zeitraums erfolgreich Energieverbrauchswerte zum Endzeitpunkt abgerufen wurden, an allen Geräten',
        'Full Integrity Rate Description': 'Vollständige Daten-Integritätsrate: Anteil der Geräte, bei denen während des statistischen Zeitraums erfolgreich Energieverbrauchswerte sowohl zum Start- als auch zum Endzeitpunkt abgerufen wurden, an allen Geräten',
        //Equipment Tracking
        'Equipment List': 'Ausrüstungsliste',
        'Edit Equipment': 'bearbeiten',
        //Profile Dropdown
        Feedback: 'Feedback',
        'Account Settings': 'Kontoeinstellungen',
        Logout: 'Ausloggen',
        //Authentication
        'Log in': 'Anmeldung',
        'Email address': 'E-Mail-Addresse',
        'Phone Number': 'Telefonnummer',
        Password: 'Passwort',
        CaptchaCode: 'Captcha',
        Refresh: 'Auffrischen',
        'Remember me': 'Behalte mich in Erinnerung',
        'Logged in as ': 'Angemeldet als ',
        'Forgot Password?': 'Passwort vergessen?',
        'Forgot your password?': 'Passwort vergessen?',
        "Enter your email and we'll send you a reset link":
            'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen',
        "Enter your email and we'll send you a registration link":
            'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen den Registrierungslink zu',
        'Reset Password': 'Passwort zurücksetzen',
        'Thanks for using QiXuan!': 'Vielen Dank, dass Sie QiXuan verwenden!',
        'You are now successfully signed out': 'Sie sind jetzt erfolgreich abgemeldet',
        'Return to Login': 'Zurück zum Login',
        'Please check your email!': 'Bitte überprüfen Sie Ihre E-Mails!',
        'An email has been sent to ': 'Eine email wurde gesendet an ',
        'Please click on the included link to reset your password':
            'Bitte klicken Sie auf den enthaltenen Link, um Ihr Passwort zurückzusetzen',
        'Please click on the included link to register your account':
            'Bitte klicken Sie auf den beigefügten Link, um Ihr Konto zu registrieren.',
        'An email with password reset link is sent to ':
            'Eine E-Mail mit einem Link zum Zurücksetzen des Passworts wird an gesendet ',
        'Change Password': 'Ändere das Passwort',
        'Old Password': 'Altes Passwort',
        'New Password': 'Neues Kennwort',
        'Confirm Password': 'Bestätige das Passwort',
        'Update Password': 'Kennwort aktualisieren',
        'Password has been changed!': 'Das Passwort wurde geändert!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below.':
            'Der Bestätigungscode wurde an Ihr Postfach gesendet. \
  Bitte kopieren Sie ihn in das Eingabefeld unten.',
        'New to QiXuan': 'Neu bei QiXuan',
        'Create an account': 'Ein Konto erstellen',
        'EMAIL Account registration successful': '{{EMAIL}} Konto erfolgreich registriert',
        'Thanks for verifying your account!': 'Vielen Dank, dass Sie Ihr Konto verifiziert haben!',
        'Your code is': 'Ihr Code lautet',
        'Send verification code': 'Verifizierungscode gesendet',
        'Please wait for NUMBER seconds': 'Bitte warten Sie {{NUMBER}} Sekunden',
        'Password reset': 'Passwort zurücksetzen',
        'Please wait for approval': 'Bitte warten Sie auf Genehmigung',
        //notification
        Notifications: 'Benachrichtigungen',
        'Mark all as read': 'Markiere alle als gelesen',
        'View all': 'Alle',
        'Notification New': 'Neu',
        'Notification Earlier': 'Vorhin',
        'Notification List': 'Benachrichtigungsliste',
        'Bulk actions': 'Massenaktionen',
        'Notification Subject': 'Betreff',
        'Notification Created Datetime': 'Datetime erstellt',
        'Notification Priority': 'Priorität',
        'Notification Message': 'Nachricht',
        'Notification Status': 'Status',
        'Notification Mark As Read': 'Mark as read',
        'Notification Mark As Acknowledged': 'Bestätigen',
        'Notification Low': 'Niedrig',
        'Notification Medium': 'Mittelmaß',
        'Notification High': 'Hoch',
        'Notification Critical': 'Kritisch',
        'Notification Unread': 'Ungelesene',
        'Notification Read': 'Lesen',
        'Notification Acknowledged': 'Anerkannt',
        'Notification Archive': 'Archiv',
        'Notification Delete': 'Löschen',
        'Notification Apply': 'Anwenden',
        'Notification Start Datetime': 'Starten Sie Datetime',
        'Notification End Datetime': 'Datum/Uhrzeit beenden',
        'Notification Update Datetime': 'Datum/Uhrzeit aktualisieren',
        //Monitoring
        'Run Commands': 'Befehle ausführen',
        'Pin Code': 'PIN-Code',
        'Unlock': 'Freischalten',
        'Set Value': 'Wert festlegen',
        'Fault Alarms': 'Fehleralarme',
        'Instantaneous Efficiency VALUE UNIT': 'Sofortige Effizienz {{VALUE}} {{UNIT}}',
        'Communication Status': 'Kommunikationsstatus',
        'Communication Online': 'Online',
        'Communication Offline': 'Offline',
        'Equipment Status': 'Ausrüstung Status',
        'Equipment Running': 'Läuft',
        'Equipment Stopped': 'Gestoppt',
        'Show Up to': 'Zeigen Sie bis zu',
        All: 'Alles',
        'FROM - TO of TOTAL': 'Die aktuelle Anzeige von {{FROM}} und {{TO}} total {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': 'Mikronetz-Energie',
        'Microgrid Revenue': 'Mikronetz-Umsatz',
        'Microgrid Carbon': 'Mikronetz-Kohlenstoff',
        'Photovoltaic Generation': 'Photovoltaik-Erzeugung',
        'EV Charger Consumption': 'EV-Ladegerät-Verbrauch',
        'Load Consumption': 'Lastverbrauch',
        'Grid Buy': 'Netzbezug',
        'Grid Sell': 'Netzeinspeisung',
        'EV Charger': 'EV-Ladegerät',
        'Heat Pump': 'Wärmepumpe',
        'Photovoltaic': 'Photovoltaik',
        'PCS Run State': 'PCS-Ausführungsstatus',
        'PCS Unknown': 'Unbekannt',
        'PCS Initializing': 'Initialisieren',
        'PCS Standby': 'Standby',
        'PCS Shutdown': 'Herunterfahren',
        'PCS Fault': 'Fehler',
        'PCS Running': 'Laufend',
        'Battery Power': 'Batterieleistung',
        'Photovoltaic Power': 'Photovoltaik',
        'Grid Power': 'Netzleistung',
        'Load Power': 'Lastleistung',
        Reporting: 'Berichterstattung',
        Maintenance: 'Wartung',
        'Serial Number': 'Seriennummer',
        Address: 'Adresse',
        'Postal Code': 'Postleitzahl',
        'Rated Capacity': 'Nennleistung',
        'Rated Power': 'Nennleistung',
        Latitude: 'Breitengrad',
        Longitude: 'Längengrad',
        'Strategy Management': 'Strategiemanagement',
        'Charging Schedule': 'Ladeplan',
        'Charge Start Time': 'Ladestartzeit',
        'Charge End Time': 'Endzeit der Ladung',
        'Discharge Start Time': 'Startzeit der Entladung',
        'Discharge End Time': 'Endzeit der Entladung',
        'Total Rated Power': 'Nennleistung insgesamt',
        'Total Rated Capacity': 'Gesamtnennkapazität',
        // Energy Indicator
        "Today's Charge": "Das heutige Ladevolumen",
        "Today's Discharge": "Die heutige Entladungskapazität",
        "Today's Generation": "Die heutige Stromerzeugung",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'Gesamtbetrag',
        'Total Discharge': 'totale Entladung',
        'Total Generation': 'Gesamtgeneration',
        'Total Revenue': 'Gesamtumsatz',
        'Total Photovoltaic Generation': 'Gesamte Photovoltaik-Erzeugung',
        'Total EV Charger Consumption': 'Gesamter EV-Ladegerät-Verbrauch',
        'Total Load Consumption': 'Gesamter Lastverbrauch',
        'Total Grid Buy': 'Gesamter Netzbezug',
        'Total Grid Sell': 'Gesamter Netzeinspeisung',
        'Total Efficiency': 'Gesamtwirkungsgrad',
        'Discharge Achievement Rate': 'Entladungsleistungsrate',
        // Revenue Indicator
        "Today's Cost": "Today's Cost",
        "Today's Income": "Today's Income",
        "Total Cost": "Total Cost",
        "Total Income": "Total Income",
        "Today's Revenue": "Today's Revenue",

        'Revenue Ranking': 'Umsatzranking',
        'Efficiency Ranking': 'Effizienzranking',
        'Charge Ranking': 'Rangliste der Ladekapazitäten',
        'Discharge Ranking': 'Entlassungsrangliste',
        'Number of Microgrids': 'Anzahl der Mikronetze',
        'Number of Power Stations': 'Anzahl der Kraftwerke',
        'Microgrid List': 'Microgrid-Liste',
        'Select Microgrid': 'Mikronetz auswählen',
        'Previous Page': 'Vorherige Seite',
        'Next Page': 'Nächste Seite',
        '7 Days': '7 Tage',
        'Charge UNIT': 'Aufladung {{UNIT}}',
        'Discharge UNIT': 'Entladung {{UNIT}}',
        'Generation UNIT': 'Strom erzeugen {{UNIT}}',
        'Energy Indicator': 'Energieanzeige',
        'Revenue Indicator': 'Umsatzindikator',
        'Carbon Indicator': 'Kohlenstoffindikator',

        // Energy Storage Power Station
        'Battery Operating State': 'Batteriebetriebszustand',
        'Battery State': 'Batteriestatus',
        'Battery Unknown': 'Unbekannt',
        'Battery Stopped': 'Angehalten',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'Fehler', // 1
        'Battery Warning': 'Warnung', // 2
        'Battery Standby': 'Standby', // 3
        'Battery Prohibit DisCharging': 'Deaktivieren verbieten', // 4
        'Battery Prohibit Charging': 'Gebühren verbieten', // 5
        'Battery Normal': 'Normal', // 6
        'Battery Charging': 'Aufladung', // 7
        'Battery Discharging': 'Selama pembebasan', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'Phase des Lebenszyklus',
        'Use Phase': 'Anwendungsphase',
        'Commissioning Phase': 'Phase der Inbetriebnahme',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'Installationsphase',
        'Device Status': 'Gerätestatus',
        'Basic Information': 'Grundlegende Informationen',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'Wechselrichter',
        'Invertor Run State': 'Ausführungsstatus',
        'Invertor Unknown': 'Unbekannt',
        'Invertor Initializing': 'Initialisieren',
        'Invertor Standby': 'Standby',
        'Invertor Shutdown': 'Herunterfahren',
        'Invertor Fault': 'Fehler',
        'Invertor Running': 'Laufend',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': 'Datetime erstellt',
        'File Format': 'Datei Format',
        'File Size': 'Dateigröße',
        Uploader: 'Uploader',
        'Upload Datetime': 'Datetime hochladen',
        //Error
        "The page you're looking for is not found": 'Die gesuchte Seite wurde nicht gefunden',
        "Make sure the address is correct and that the page hasn't moved. ":
            'Stellen Sie sicher, dass die Adresse korrekt ist und die Seite nicht verschoben wurde',
        'If you think this is a mistake,': 'Wenn Sie denken, dass dies ein Fehler ist,',
        'contact us': 'kontaktiere uns',
        'Take me home': 'Bring mich zurück zur Homepage',
        'Whoops, something went wrong!': 'Oh, etwas ist schief gelaufen!',
        'Try refreshing the page, or going back and attempting the action again. ':
            'Versuchen Sie, die Seite zu aktualisieren, oder gehen Sie zurück und versuchen Sie die Aktion erneut. ',
        'If this problem persists,': 'Wenn dieses Problem weiterhin besteht,',
        'Captcha Error': 'Captcha-Fehler',
        'Confirm Password Error': 'Das Bestätigungspasswort stimmt nicht überein',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Es scheint, als hättest \
  du auf einen ungültigen Link zur Passwortrücksetzung geklickt. Bitte versuche es erneut.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Es sieht so aus, als hätten \
  Sie auf einen ungültigen Registrierungslink geklickt. Bitte versuchen Sie es erneut.',
        //Tenant Bill
        'Lease Contract Number': 'Mietvertragsnummer',
        Download: 'Herunterladen',
        Print: 'Drucken',
        'Payment Notice': 'Zahlungshinweis',
        'Bill To': 'Zu',
        'Bill Number': 'Rechnungsnummer',
        'Bill Date': 'Rechnungsdatum',
        'Payment Due Date': 'Fälligkeitsdatum',
        'Amount Payable': 'Bezahlbarer Betrag',
        'Billing Period Start': 'Beginn des Abrechnungszeitraums',
        'Billing Period End': 'Ende des Abrechnungszeitraums',
        Quantity: 'Menge',
        Price: 'Preis',
        Unit: 'Maßeinheit',
        Amount: 'Geldbetrag',
        Subtotal: 'Zwischensumme',
        'VAT Output Tax': 'Mehrwertsteuer Ausgangssteuer',
        'Total Amount Payable': 'Gesamtbetrag zahlbar',
        'Please make sure to pay on or before the payment due date above':
            'Bitte stellen Sie sicher, dass Sie am oder vor dem oben genannten Fälligkeitsdatum bezahlen',
        'Send money to the following account': 'Senden Sie Geld auf das folgende Konto',
        'Account Name': 'Kontobezeichnung',
        'Bank Name': 'Bank Name',
        'Bank Address': 'Bankadresse',
        'RMB Account': 'RMB-Konto',
        // button
        'Toggle Navigation': 'Navigation umschalten',
        // working calendar
        'Working Days': 'Arbeitstage',
        'Non Working Days': 'Arbeitsfreie Tage',
        'Select Row': 'Bitte wählen Sie die zu bearbeitende Zeile aus',
        // Offline Meter Input
        'Daily Value': 'Tageswert',
        Date: 'Datum',
        'Successfully Saved': 'Betrieb erfolgreich',
        'Previous Data Is Empty': 'Vorherige Daten sind leer',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administratorsitzung nicht gefunden',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Zeitüberschreitung für Administratorsitzungen',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Erweiterter Bericht nicht gefunden',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Ungültige Anfrage',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER':
            'Vorhandenes Submeter kann nicht als Mastermeter festgelegt werden',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Kombinierte Ausrüstungsausrüstung besteht',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Kombinierte Ausrüstungsausrüstung nicht gefunden',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Kombinierte Gerätezählerbeziehung besteht',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Kombinierte Gerätezählerbeziehung nicht gefunden',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Kombinierter Gerätename wird bereits verwendet',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Kombinierte Ausrüstung nicht gefunden',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Kombinierte Geräte-Offline-Zählerbeziehung besteht',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND':
            'Kombinierte Geräte-Offline-Zählerbeziehung nicht gefunden',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE':
            'Der Name des kombinierten Geräteparameters wird bereits verwendet',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH':
            'Parameter für kombinierte Ausrüstung nicht gefunden oder stimmt nicht überein',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS':
            'Kombinierte Ausrüstung virtuelle Zählerbeziehung existiert',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND':
            'Kombinierte Ausrüstung virtuelle Zählerbeziehung nicht gefunden',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Der Kontaktname wird bereits verwendet',
        'API.CONTACT_NOT_FOUND': 'Kontakt nicht gefunden',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Externe Kostenstellen-ID vorhanden',
        'API.COST_CENTER_NAME_EXISTS': 'Der Name der Kostenstelle ist vorhanden',
        'API.COST_CENTER_NOT_FOUND': 'Kostenstelle nicht gefunden',
        'API.COST_FILE_NOT_FOUND': 'Kostendatei nicht gefunden',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Der Name der Datenquelle wird bereits verwendet',
        'API.DATA_SOURCE_NOT_FOUND': 'Datenquelle nicht gefunden',
        'API.DATABASE_ERROR': 'Datenbankfehler',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Datum ist bereits im Arbeitskalender',
        'API.DATE_LOCAL_NOT_FOUND': 'Datum lokal nicht gefunden',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Der Name der Verteilungsschaltung wird bereits verwendet',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Verteilungskreis nicht gefunden',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Verteilungskreispunktbeziehung existiert',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Verteilungskreispunktbeziehung nicht gefunden',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Der Name des Verteilungssystems wird bereits verwendet',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Verteilungssystem nicht gefunden',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'E-Mail wird bereits verwendet',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'E-Mail-Nachricht nicht gefunden',
        'API.EMAIL_NOT_FOUND': 'Die E-Mail-Adresse existiert nicht',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'E-Mail-Server-Host wird bereits verwendet',
        'API.EMAIL_SERVER_NOT_FOUND': 'E-Mail-Server nicht gefunden',
        'API.EMPTY_VARIABLES_ARRAY': 'Leeres Variablen-Array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Name der Energiekategorie wird bereits verwendet',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energiekategorie nicht gefunden',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energiekategorie, die in Energieerzeugnissen verwendet wird',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energiekategorie im Zähler',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energiekategorie, die in Offline-Zählern verwendet wird',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'In Tarifen verwendete Energiekategorie',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energiekategorie, die im virtuellen Zähler verwendet wird',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energieflussdiagramm-Link wird bereits verwendet',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH':
            'Energieflussdiagramm-Link nicht gefunden oder stimmt nicht überein',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Der Name des Energieflussdiagramms wird bereits verwendet',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE':
            'Der Name des Energieflussdiagramm-Knotens wird bereits verwendet',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH':
            'Energieflussdiagrammknoten nicht gefunden oder nicht übereinstimmend',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energieflussdiagramm nicht gefunden',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energieartikel gehört nicht zur Energiekategorie',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energieartikel gehört nicht zur Energiekategorie',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Name des Energieelements wird bereits verwendet',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energieartikel nicht gefunden',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energieelement, das im Zähler verwendet wird',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energieelement, das im Offline-Zähler verwendet wird',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energieelement, das im virtuellen Zähler verwendet wird',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Gerätezählerbeziehung besteht',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Gerätezählerbeziehung nicht gefunden',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Gerätename wird bereits verwendet',
        'API.EQUIPMENT_NOT_FOUND': 'Ausrüstung nicht gefunden',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Geräte-Offline-Zählerbeziehung existiert',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Geräte-Offline-Zählerbeziehung nicht gefunden',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Der Name des Geräteparameters wird bereits verwendet',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment-Parameter nicht gefunden oder stimmt nicht überein',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Virtuelle Zählerbeziehung der Ausrüstung existiert',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Virtuelle Gerätezählerbeziehung nicht gefunden',
        'API.ERROR': 'Fehler',
        'API.EXCEPTION': 'Ausnahme',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Kostendatei konnte nicht wiederhergestellt werden',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Fehler beim Wiederherstellen der Wissensdatei',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Offline-Zählerdatei konnte nicht wiederhergestellt werden',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Offline-Zählerdatei konnte nicht gespeichert werden',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Kostendatei konnte nicht hochgeladen werden',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Wissensdatei konnte nicht hochgeladen werden',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Offline-Zählerdatei konnte nicht hochgeladen werden',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway-Name wird bereits verwendet',
        'API.GATEWAY_NOT_FOUND': 'Gateway nicht gefunden',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Ungültig ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Ungültige Adresse',
        'API.INVALID_ADDRESS_VALUE': 'Ungültiger Adresswert',
        'API.INVALID_ADVANCED_REPORT_ID': 'Ungültige erweiterte Berichts-ID',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Ungültiger Flächenwert',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Ungültige Basisperiode EnddatumUhrzeit',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Startdatum ungültiger BasiszeitraumUhrzeit',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Ungültige Baudrate',
        'API.INVALID_BUILDINGS_VALUE': 'Ungültiger Gebäudewert',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Ungültige Kategorie',
        'API.INVALID_CHANNEL': 'Ungültiger Kanal',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Ungültige kombinierte Geräte-ID',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Ungültiger kombinierter Gerätename',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Ungültige kombinierte Geräteparameter-ID',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Ungültiger kombinierter Geräteparametername',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Ungültiger kombinierter Geräteparametertyp',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Ungültige kombinierte Geräte-uuid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Ungültige Verbindung',
        'API.INVALID_CONSTANT_VALUE': 'Ungültiger konstanter Wert',
        'API.INVALID_CONTACT_ID': 'Ungültige Kontakt-ID',
        'API.INVALID_CONTACT_NAME': 'Ungültiger Kontaktname',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Ungültige Kostenstellen-ID',
        'API.INVALID_COST_FILE_ID': 'Ungültige Kostendatei-ID',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Ungültige Datenquellen-ID',
        'API.INVALID_DATA_SOURCE_NAME': 'Ungültiger Datenquellenname',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Ungültiges Datenquellenprotokoll',
        'API.INVALID_DATE_LOCAL': 'Ungültiges lokales Datum',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Ungültiger Nenner Meter uuid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Ungültiger Anzeigename',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Ungültige Verteilungskreis-ID',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Ungültiger Verteilungskreisname',
        'API.INVALID_DISTRIBUTION_ROOM': 'Ungültiger Verteilungsraum',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Ungültige Verteilungssystem-ID',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Ungültiger Verteilungssystemname',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Ungültige E-Mail-Adresse',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Ungültige E-Mail-Nachrichten-ID',
        'API.INVALID_EMAIL_SERVER_HOST': 'Ungültiger E-Mail-Server-Host',
        'API.INVALID_EMAIL_SERVER_ID': 'Ungültige E-Mail-Server-ID',
        'API.INVALID_END_DATE_FORMAT': 'Ungültiges Enddatumsformat',
        'API.INVALID_END_DATETIME': 'Ungültige Enddatumszeit',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Ungültige Energiekategorie-ID',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Ungültiger Energiekategoriename',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Ungültige Energieflussdiagramm-ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Ungültige Energieflussdiagramm-Link-ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Ungültiger Name des Energieflussdiagramms',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Ungültige Energieflussdiagramm-Knoten-ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Ungültiger Energieflussdiagramm-Knotenname',
        'API.INVALID_ENERGY_ITEM_ID': 'Ungültige Energieelement-ID',
        'API.INVALID_ENERGY_ITEM_NAME': 'Ungültiger Energieelementname',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Ungültige Gleichung im Ausdruck',
        'API.INVALID_EQUIPMENT_ID': 'Ungültige Geräte-ID',
        'API.INVALID_EQUIPMENT_NAME': 'Ungültiger Gerätename',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Ungültige Geräteparameter-ID',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Ungültiger Geräteparametername',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Ungültiger Geräteparametertyp',
        'API.INVALID_EQUIPMENT_UUID': 'Ungültige Geräteuuid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Ungültiger Ausdruck',
        'API.INVALID_EXPRESSION_OBJECT': 'Ungültiges Ausdrucksobjekt',
        'API.INVALID_FDD_CODE': 'Ungültiger FDD-Code',
        'API.INVALID_FLOORS_VALUE': 'Ungültiger Wert für Böden',
        'API.INVALID_FROM_ADDR': 'Ungültig von addr',
        'API.INVALID_GATEWAY_ID': 'Ungültige Gateway-ID',
        'API.INVALID_GATEWAY_NAME': 'Ungültiger Gatewayname',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Ungültiger stündlich hoher Grenzwert',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Ungültiger stündlicher niedriger Grenzwert',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Ungültig ist admin-Wert',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Ungültiger Wert wird gezählt',
        'API.INVALID_IS_ENABLED': 'Ungültig ist aktiviert',
        'API.INVALID_IS_HIDDEN': 'Ungültig ist ausgeblendet',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Ungültig ist im Leasingwert',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Ungültig ist der gezählte Eingabewert',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Ungültig ist Schlüsselmandantenwert',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Ungültig ist der gezählte Ausgabewert',
        'API.INVALID_IS_OUTPUT_VALUE': 'Ungültig ist Ausgabewert',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Ungültig ist Trendwert',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Ungültig ist virtueller Wert',
        'API.INVALID_KGCE': 'Ungültige kgce',
        'API.INVALID_KGCO2E': 'Ungültiges kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Ungültige Wissensdatei-ID',
        'API.INVALID_LATITUDE_VALUE': 'Ungültiger Breitengradwert',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Ungültiger Wert der Leasenummer',
        'API.INVALID_LONGITUDE_VALUE': 'Ungültiger Längengrad',
        'API.INVALID_LOW_LIMIT_VALUE': 'Ungültiger niedriger Grenzwert',
        'API.INVALID_MASTER_METER_ID': 'Ungültige Masterzähler-ID',
        'API.INVALID_MENU_ID': 'Ungültige Menü-ID',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Ungültige Nachrichtenvorlage',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Ungültige Zähler-ID',
        'API.INVALID_METER_NAME': 'Ungültiger Zählername',
        'API.INVALID_METER_UUID': 'ungültiger Meter UUID',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Ungültiger Namenswert',
        'API.INVALID_NEW_PASSWORD': 'Ungültiges neues Kennwort',
        'API.INVALID_NON_WORKING_DAY_ID': 'Ungültige arbeitsfreie ID',
        'API.INVALID_NOTIFICATION_ID': 'Ungültige Benachrichtigungs-ID',
        'API.INVALID_NUMERATOR_METER_UUID': 'Ungültige Zählerzählerzähler-UUID',
        'API.INVALID_OBJECT_TYPE': 'Ungültiger Objekttyp',
        'API.INVALID_OFFLINE_METER_DATA': 'Ungültige Offline-Zählerdaten',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Ungültige Offline-Zählerdatei-ID',
        'API.INVALID_OFFLINE_METER_ID': 'Ungültige Offline-Zähler-ID',
        'API.INVALID_OFFLINE_METER_NAME': 'Ungültiger Offline-Zählername',
        'API.INVALID_OFFLINE_METER_UUID': 'Ungültige Offline-Zähler-uuid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Ungültiger Wert der Offset-Konstante',
        'API.INVALID_OLD_PASSWORD': 'Ungültiges altes Passwort',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Ungültige ID des übergeordneten Bereichs',
        'API.INVALID_PASSWORD': 'Ungültiges Kennwort',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Ungültiger Spitzenstrom',
        'API.INVALID_PEAK_LOAD': 'Ungültige Spitzenlast',
        'API.INVALID_PERIOD_TYPE': 'Ungültiger Periodentyp',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Ungültige Punkt-ID',
        'API.INVALID_POINT_NAME': 'Ungültiger Punktname',
        'API.INVALID_PORT': 'Ungültiger Port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Ungültige Priorität',
        'API.INVALID_PRIVILEGE': 'Ungültige Berechtigung',
        'API.INVALID_PRIVILEGE_DATA': 'Ungültige Berechtigungsdaten',
        'API.INVALID_PRIVILEGE_ID': 'Ungültige Berechtigungs-ID',
        'API.INVALID_PRIVILEGE_NAME': 'Ungültiger Berechtigungsname',
        'API.INVALID_RATIO_VALUE': 'Ungültiger Verhältniswert',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Ungültige Antwort',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Ungültige Berichtsperiode EnddatumUhrzeit',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Startdatum des ungültigen Berichtszeitraums',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Ungültig erfordert Authentifizierung',
        'API.INVALID_ROOMS_VALUE': 'Ungültiger Zimmerwert',
        'API.INVALID_RULE_ID': 'Ungültige Regel-ID',
        'API.INVALID_RULE_NAME': 'Ungültiger Regelname',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Ungültige Sensor-ID',
        'API.INVALID_SENSOR_NAME': 'Ungültiger Sensorname',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_PORT': 'Ungültiger serieller Port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Ungültige Sitzung, bitte melden Sie sich erneut an',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Ungültige Shopfloor-ID',
        'API.INVALID_SHOPFLOOR_NAME': 'Ungültiger Shopfloor-Name',
        'API.INVALID_SHOPFLOOR_UUID': 'Ungültige Shopfloor-uuid',
        'API.INVALID_SOURCE_NODE_ID': 'Ungültige Quellknoten-ID',
        'API.INVALID_SPACE_ID': 'Ungültige Speicherplatz-ID',
        'API.INVALID_SPACE_NAME': 'Ungültiger Leerzeichenname',
        'API.INVALID_SPACE_UUID': 'Ungültiges Leerzeichen uuid',
        'API.INVALID_START_DATE_FORMAT': 'Ungültiges Startdatumsformat',
        'API.INVALID_START_DATETIME': 'Ungültiges StartdatumUhrzeit',
        'API.INVALID_STATUS': 'Ungültiger Status',
        'API.INVALID_STORE_ID': 'Ungültige Store-ID',
        'API.INVALID_STORE_NAME': 'Ungültiger Store-Name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Beschreibung des ungültigen Shop-Typs',
        'API.INVALID_STORE_TYPE_ID': 'Ungültige Speichertyp-ID',
        'API.INVALID_STORE_TYPE_NAME': 'Ungültiger Name des Speichertyps',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Ungültiger vereinfachter Code für den Shop-Typ',
        'API.INVALID_STORE_UUID': 'Ungültige Speicher-uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Ungültiges SVG',
        'API.INVALID_SWITCHGEAR': 'Ungültige Schaltanlage',
        'API.INVALID_TARGET_NODE_ID': 'Ungültige Zielknoten-ID',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Ungültige Tarifpauschale',
        'API.INVALID_TARIFF_ID': 'Ungültige Tarif-ID',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Ungültiger Tarifpreis für Nutzungszeit',
        'API.INVALID_TARIFF_TYPE': 'Ungültiger Tariftyp',
        'API.INVALID_TENANT_ID': 'Ungültige Mandanten-ID',
        'API.INVALID_TENANT_NAME': 'Ungültiger Mandantenname',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Beschreibung des ungültigen Mandantentyps',
        'API.INVALID_TENANT_TYPE_ID': 'Ungültige Mandantentyp-ID',
        'API.INVALID_TENANT_TYPE_NAME': 'Ungültiger Mandantentypname',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Ungültiger vereinfachter Mandantentyp',
        'API.INVALID_TENANT_UUID': 'Ungültige Mandanten-UUID',
        'API.INVALID_TEXT_MESSAGE_ID': 'Ungültige SMS-ID',
        'API.INVALID_TIMEZONE_ID': 'Ungültige Zeitzonen-ID',
        'API.INVALID_TOKEN': 'Ungültiges Token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Ungültige Mengeneinheit',
        'API.INVALID_UNIT_OF_PRICE': 'Ungültige Preiseinheit',
        'API.INVALID_UNITS': 'Ungültige Einheiten',
        'API.INVALID_USER_ID': 'Ungültige Benutzer-ID',
        'API.INVALID_USER_NAME': 'Ungültiger Benutzername',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Ungültiger Benutzername oder ungültige E-Mail-Adresse',
        'API.INVALID_USER_PHONE': 'Ungültiges Benutzertelefon',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Ungültiger Benutzer, bitte erneut anmelden',
        'API.INVALID_USER_UUID': 'Ungültige Benutzer-UUID',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Ungültige variable Zähler-ID',
        'API.INVALID_VARIABLE_METER_TYPE': 'Ungültiger variabler Zählertyp',
        'API.INVALID_VARIABLE_NAME': 'Ungültiger Variablenname',
        'API.INVALID_VERIFICATION_CODE': 'Ungültiger Bestätigungscode',
        'API.INVALID_VIRTUAL_METER_ID': 'Ungültige ID des virtuellen Zählers',
        'API.INVALID_VIRTUAL_METER_NAME': 'Ungültiger Name des virtuellen Zählers',
        'API.INVALID_VIRTUAL_METER_UUID': 'Ungültige uuid des virtuellen Zählers',
        'API.INVALID_WEB_MESSAGE_ID': 'Ungültige Webnachrichten-ID',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Ungültige wechat-Nachrichten-ID',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Ungültige Arbeitskalender-ID ',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Ungültiger Arbeitskalender Name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Wissensdatei kann nicht vom Datenträger entfernt werden',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Wissensdatei nicht gefunden',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Masterzähler gehört nicht zur gleichen Energiekategorie',
        'API.MASTER_METER_NOT_FOUND': 'Mastermeter nicht gefunden',
        'API.MENU_NOT_FOUND': 'Menü nicht gefunden',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Zählername wird bereits verwendet',
        'API.METER_NOT_FOUND': 'Meter nicht gefunden',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter der Variablen nicht gefunden',
        'API.METER_POINT_RELATION_EXISTS': 'Meterpunktbeziehung existiert',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meterpunktbeziehung nicht gefunden',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
            'Die länge des neuen codes darf nicht mehr als 100 zeichen betragen',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'arbeitsfreier Tag nicht gefunden',
        'API.NOT_FOUND': 'Nicht gefunden',
        'API.NOTIFICATION_NOT_FOUND': 'Benachrichtigung nicht gefunden',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline-Zählerdatei nicht gefunden',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Der Name des Offline-Zählers wird bereits verwendet',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline-Messgerät nicht gefunden',
        'API.INVALID_OFFLINE_METER_VALUE': 'Ungültiger Offline-Zählerwert',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline-Zähler der Variablen nicht gefunden',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
            'Die länge des alten codes darf nicht mehr als 100 zeichen betragen',
        'API.PARENT_SPACE_NOT_FOUND': 'Übergeordneter Speicherplatz nicht gefunden',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Die länge des codes darf keine 100 zeichen überschreiten',
        'API.PASSWORDS_MATCH': 'Das neue Passwort ist das gleiche wie das alte Passwort',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Punktname wird bereits verwendet',
        'API.POINT_NOT_FOUND': 'Punkt nicht gefunden',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Berechtigungsname wird bereits verwendet',
        'API.PRIVILEGE_NOT_FOUND': 'Berechtigung nicht gefunden',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Regelname wird bereits verwendet',
        'API.RULE_NOT_FOUND': 'Regel nicht gefunden',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensorname wird bereits verwendet',
        'API.SENSOR_NOT_FOUND': 'Sensor nicht gefunden',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensorpunktbeziehung existiert',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensorpunktbeziehung nicht gefunden',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor Equipment Beziehung besteht',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor Equipment Beziehung nicht gefunden',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor Meter Beziehung besteht',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor Meter Beziehung nicht gefunden',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor-Name wird bereits verwendet',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor nicht gefunden',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor Offline-Zählerbeziehung existiert',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor Offline-Zählerbeziehung nicht gefunden',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor-Punktbeziehung existiert',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor-Punktbeziehung nicht gefunden',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor-Sensorbeziehung besteht',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor-Sensorbeziehung nicht gefunden',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtuelle Zählerbeziehung existiert',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtuelle Zählerbeziehung nicht gefunden',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Es besteht eine Arbeitskalender-Shop-Beziehung',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Arbeitskalenderbeziehung für Shopfloor nicht gefunden',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Quellknoten nicht gefunden',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Raumkombinierte Ausrüstungsbeziehung besteht',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Raumkombinierte Ausrüstungsbeziehung nicht gefunden',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Raumausrüstungsbeziehung besteht',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Beziehung zwischen Weltraumausrüstung nicht gefunden',
        'API.SPACE_METER_RELATION_EXISTS': 'Raummeterbeziehung existiert',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space-Meter-Beziehung nicht gefunden',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space-Name wird bereits verwendet',
        'API.SPACE_NOT_FOUND': 'Speicherplatz nicht gefunden',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Speicherplatz nicht im Privileg gefunden',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline Meter Beziehung existiert',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Speicherplatz-Offline-Zählerbeziehung nicht gefunden',
        'API.SPACE_POINT_RELATION_EXISTS': 'Raumpunktbeziehung existiert',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Raumpunktbeziehung nicht gefunden',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Raumsensorbeziehung besteht',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Raumsensorbeziehung nicht gefunden',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Raum-Shopfloor-Beziehung besteht',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Raum-Shopfloor-Beziehung nicht gefunden',
        'API.SPACE_STORE_RELATION_EXISTS': 'Raumspeicherbeziehung existiert',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Raumspeicherbeziehung nicht gefunden',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space-Mandantenbeziehung ist vorhanden',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Raummieterbeziehung nicht gefunden',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Raumbezogene virtuelle Zählerbeziehung existiert',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Virtuelle Zählerbeziehung für den Weltraum nicht gefunden',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Arbeitskalender-Space-Beziehung vorhanden',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Arbeitskalenderbeziehung für Speicherplatz nicht gefunden',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'StartdatumUhrzeit muss früher als Enddatumszeit sein',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Speicherzählerbeziehung vorhanden',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Speicherzählerbeziehung nicht gefunden',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Der Store-Name wird bereits verwendet',
        'API.STORE_NOT_FOUND': 'Shop nicht gefunden',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Offline-Zählerbeziehung speichern ist vorhanden',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Offline-Zählerbeziehung speichern nicht gefunden',
        'API.STORE_POINT_RELATION_EXISTS': 'Speicherpunktbeziehung vorhanden',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Speicherpunktbeziehung nicht gefunden',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Speichersensorbeziehung ist vorhanden',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Sensorbeziehung nicht gefunden',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Der Name des Geschäftstyps wird bereits verwendet',
        'API.STORE_TYPE_NOT_FOUND': 'Shop-Typ nicht gefunden',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE':
            'Der vereinfachte Code für den Shop-Typ wird bereits verwendet',
        'API.STORE_TYPE_USED_IN_STORE': 'Im Store verwendeter Shop-Typ',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Virtuelle Zählerbeziehung speichern ist vorhanden',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Virtuelle Zählerbeziehung nicht gefunden',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Es besteht eine Beziehung zum Arbeitskalenderspeicher',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Arbeitskalenderbeziehung für Speicher nicht gefunden',
        'API.TARGET_NODE_NOT_FOUND': 'Zielknoten nicht gefunden',
        'API.TARIFF_IN_USE': 'Tarif im Einsatz',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tarif ist bereits mit Kostenstelle verknüpft',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tarif ist nicht mit Kostenstelle verknüpft',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tarifname wird bereits verwendet',
        'API.TARIFF_NOT_FOUND': 'Tarif nicht gefunden',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Mandantenzählerbeziehung vorhanden',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Mieterzählerbeziehung nicht gefunden',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Mandantenname wird bereits verwendet',
        'API.TENANT_NOT_FOUND': 'Mieter nicht gefunden',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Mandanten-Offlinezählerbeziehung ist vorhanden',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Mandanten-Offlinezählerbeziehung nicht gefunden',
        'API.TENANT_POINT_RELATION_EXISTS': 'Mandantenpunktbeziehung ist vorhanden',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Mandantenpunktbeziehung nicht gefunden',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Mandantensensorbeziehung ist vorhanden',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Mandantensensorbeziehung nicht gefunden',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Der Name des Mandantentyps wird bereits verwendet',
        'API.TENANT_TYPE_NOT_FOUND': 'Mandantentyp nicht gefunden',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Vereinfachter Mandantentyp wird bereits verwendet',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Im Mandanten verwendeter Mandantentyp',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Virtuelle Mandantenzählerbeziehung ist vorhanden',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Virtuelle Mandantenzählerbeziehung nicht gefunden',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Es besteht eine funktionierende Kalendermandantenbeziehung',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Arbeitskalenderbeziehung für Mandant nicht gefunden',
        'API.TEXT_MESSAGE_NOT_FOUND': 'SMS nicht gefunden',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'Der Berichtszeitraum muss länger als 15 Minuten sein',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'Es besteht ein Zusammenhang mit Kinderzählern',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'Es gibt eine Beziehung zu Kinderräumen',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
            'Es besteht ein Zusammenhang mit kombinierten Ausrüstungsparametern',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'Es besteht ein Zusammenhang mit kombinierten Ausrüstungen',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'Es besteht ein Zusammenhang mit Datenquellen',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS':
            'Es besteht ein Zusammenhang mit Energieflussdiagramm-Links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'Es gibt einen Zusammenhang mit Energiespeicherbehältern Batterien',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'Es besteht ein Zusammenhang mit Energiespeichercontainern, Netzen',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'Es besteht ein Zusammenhang mit den Lasten von Energiespeichercontainern',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'Es besteht ein Zusammenhang mit Energiespeichercontainern Energieumwandlungssystemen',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'Es besteht ein Zusammenhang mit Geräteparametern',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'Es besteht ein Zusammenhang mit Ausrüstungen',
        'API.THERE_IS_RELATION_WITH_METER': 'Es besteht ein Zusammenhang mit dem Zähler',
        'API.THERE_IS_RELATION_WITH_METERS': 'Es besteht ein Zusammenhang mit Zählern',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'Es besteht ein Zusammenhang mit dem Offline-Zähler',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'Es besteht ein Zusammenhang mit Offline-Zählern',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'Es besteht ein Bezug zu anderen virtuellen Zählern',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'Es besteht ein Zusammenhang mit Sensoren',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'Es besteht ein Zusammenhang mit Shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'Es gibt einen Bezug zu Räumen',
        'API.THERE_IS_RELATION_WITH_STORES': 'Es besteht eine Beziehung zu Geschäften',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'Es besteht eine Beziehung zu den Mietern',
        'API.THERE_IS_RELATION_WITH_USERS': 'Es besteht eine Beziehung zu den Benutzern',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'Es besteht ein Zusammenhang mit dem virtuellen Zähler',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Es gibt Beziehungen zu virtuellen Kraftwerken',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'Diese Datenquelle wird von einem Messgerät verwendet',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'Dieser Zähler wird von einem virtuellen Zähler verwendet',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER':
            'Dieser Offline-Zähler wird von einem virtuellen Zähler verwendet',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'Dieser Speicherplatz kann nicht gelöscht werden',
        'API.TIMEZONE_NOT_FOUND': 'Zeitzone nicht gefunden',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token nicht in Headern gefunden, bitte melden Sie sich an',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'Benutzerkonto wurde gesperrt',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'Benutzerkonto ist abgelaufen',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'Der Benutzername wird bereits verwendet',
        'API.USER_NOT_FOUND': 'Benutzer nicht gefunden',
        'API.USER_PASSWORD_HAS_EXPIRED': 'Benutzerkennwort ist abgelaufen',
        'API.USER_PRIVILEGE_NOT_FOUND': 'Benutzerberechtigung nicht gefunden',
        'API.USER_SESSION_NOT_FOUND': 'Benutzersitzung nicht gefunden',
        'API.USER_SESSION_TIMEOUT': 'Zeitüberschreitung der Benutzersitzung',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN':
            'Benutzer uuid nicht in Headern gefunden Bitte melden Sie sich an',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Der Name des virtuellen Zählers wird bereits verwendet',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtueller Zähler nicht gefunden',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtueller Zähler der Variablen nicht gefunden',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtueller Punkt sollte analoger Wert sein',
        'API.WEB_MESSAGE_NOT_FOUND': 'Webnachricht nicht gefunden',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat-Nachricht nicht gefunden',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Der Name des Arbeitskalenders wird bereits verwendet',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Arbeitskalender nicht gefunden',

        MasterMeter: 'Übersichtstabelle',
        SubMeter: 'Subtable',
        'Power Quality': "Qualité de l’énergie",
        'About Power Quality': "À propos de la qualité de l’énergie",
        'Trend Values': 'Valeurs de tendance',
        Category: 'Catégorie',
        Type: 'Type',
        Limit: 'Limite',
        'Normal Limit': 'Limite normale',
        'Severe Limit': 'Limite sévère',
        Compliance: 'Taux de conformité',
        'Worst Deviation': 'Pire écart',
        'Worst Time': "Heure du pire écart",
        'Severe Exceed Count': 'Nb de dépassements sévères',
        'Worst Unbalance': 'Déséquilibre maximal',
        Hz: 'Hz',
        voltage: 'Tension',
        current: 'Courant',
        frequency: 'Fréquence',
        voltage_deviation: 'Écart de tension',
        current_unbalance: 'Déséquilibre de courant',
        voltage_unbalance: 'Déséquilibre de tension',
        mean_deviation_pct: 'Écart moyen (%)',
        p95_abs_deviation_pct: 'Écart absolu P95 (%)',
        mean_abs_deviation_hz: 'Écart absolu moyen (Hz)',
        frequency_deviation: 'Écart de fréquence',
        p95_abs_deviation_hz: 'Écart absolu P95 (Hz)',
        mean_unbalance_pct: 'Déséquilibre moyen (%)',
        p95_unbalance_pct: 'Déséquilibre P95 (%)',
        count: 'Compte',
        min: 'Min',
        max: 'Max',
        mean: 'Moyenne',
        std: 'Écart-type',
        p5: 'P5',
        p95: 'P95'
    }
};
